import _placeholder from "./_placeholder.js";
export default function _isPlaceholder(a) {
  return a === _placeholder;
}